import {
  LOCAL_AD_TYPE,
  PRO_TYPE,
  PROMOTIONS_TYPE,
  SBOTD_TYPE
} from '../components/tableData';
import { analyticEvent } from './common';
import constants, { YES } from '../constants/constants';

const typeMap = {
  [PROMOTIONS_TYPE]: 'hd',
  [LOCAL_AD_TYPE]: 'lcl',
  [PRO_TYPE]: 'pro',
  [SBOTD_TYPE]: 'sbotd'
};

// maps subscription to analytic string ("currying")
const convertSubToAnalytic = (type) => (sub) => {
  const mappedSub = typeMap[sub.type];
  const value = (sub.value === YES) ? 'y' : 'n';
  return `${type}${mappedSub}>${value}`;
};

function preferenceAnalytic(type, subs) {
  const subConverter = convertSubToAnalytic(type);

  // converts list of subscriptions to single joined string
  const updates = subs.map(subConverter).join('|');

  const settings = 'mktg pref:' + updates;

  return analyticEvent(settings);
}

export function smsAnalytics(subs) {
  return preferenceAnalytic('sms_', subs);
}

export function emailAnalyticEvent(subs) {
  return preferenceAnalytic('eml_', subs);
}
